import { type HttpClientRequestConfig } from 'core/infra/http/HttpClient'

import { TokenExpiredError } from 'auth/errors/TokenExpiredError'
import { createMagicLinkHttpClient } from 'auth/infra/createMagicLinkHttpClient'
import { isTokenExpiredError } from 'auth/infra/isTokenExpiredError'

import { ForbiddenCarrierProfileError } from '../domain/errors/ForbiddenCarrierProfileError'
import { IncorrectCredentialsError } from '../domain/errors/IncorrectCredentialsError'
import { type User } from '../domain/User'
import { isForbiddenCarrierProfileError } from '../infra/isForbiddenCarrierProfileError'
import { isIncorrectCredentialsError } from '../infra/isIncorrectCredentialsError'
import { UserRepository } from '../infra/UserRepository'

export type GetCurrentUserFactoryDependencies = {
  userRepository: UserRepository
}

export function getCurrentUserFactory({ userRepository }: GetCurrentUserFactoryDependencies) {
  return async function getCurrentUserImpl(
    config?: Partial<HttpClientRequestConfig>
  ): Promise<User> {
    try {
      return await userRepository.getCurrentUser(config)
    } catch (error) {
      if (isTokenExpiredError(error)) {
        throw new TokenExpiredError()
      }

      if (isIncorrectCredentialsError(error)) {
        throw new IncorrectCredentialsError()
      }

      if (isForbiddenCarrierProfileError(error)) {
        throw new ForbiddenCarrierProfileError()
      }

      throw error
    }
  }
}

export function getCurrentUser(config?: Partial<HttpClientRequestConfig>): Promise<User> {
  const httpClient = createMagicLinkHttpClient()
  const userRepository = new UserRepository({ httpClient })
  const get = getCurrentUserFactory({ userRepository })

  return get(config)
}
